import React, { useState } from "react";
import { Form, Input, Button, Alert, Typography, Card } from "antd";
import { login } from "./api";

const { Title } = Typography;

export default function LoginPage({ onLogin }: { onLogin: () => void }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onFinish = async (values: { email: string; password: string }) => {
    setLoading(true);
    setError(null);
    try {
      const data = await login(values.email, values.password);
      localStorage.setItem("jwt", data.access_token);
      onLogin();
    } catch (e: any) {
      setError(e.message || "Ошибка сети");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f0f2f5" }}>
      <Card style={{ width: 350, boxShadow: "0 4px 24px rgba(0,0,0,0.08)" }}>
        <Title level={3} style={{ textAlign: "center", marginBottom: 24 }}>
          Вход в админку
        </Title>
        <Form layout="vertical" onFinish={onFinish} autoComplete="off">
          <Form.Item 
            label="Email" 
            name="email" 
            rules={[
              { required: true, message: "Введите email" },
              { type: 'email', message: 'Введите корректный email' }
            ]}
          > 
            <Input placeholder="admin@example.com" autoComplete="off" />
          </Form.Item>
          <Form.Item label="Пароль" name="password" rules={[{ required: true, message: "Введите пароль" }]}> 
            <Input.Password placeholder="Пароль" autoComplete="new-password" />
          </Form.Item>
          <Button type="primary" htmlType="submit" block loading={loading} style={{ marginTop: 8 }}>
            Войти
          </Button>
          {error && <Alert type="error" message={error} style={{ marginTop: 16 }} showIcon />}
        </Form>
      </Card>
    </div>
  );
} 